import { useLocation } from 'react-router';

export const useStatePath = () => {
  const location = useLocation();
  return location.pathname + location.search;
};
